'use client';

import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { AvailabilityLabel } from '@eliadmin/core/src/components/product/availability-label';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { isSellable as isSellableFn } from '@eliadmin/core/src/utils/product-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';

export type ProductStockProps = {
  className?: string;
  product?: Product;
  enableTooltip?: boolean;
  enableProductStatusText?: boolean;
};

export function ProductStock({
  className,
  enableTooltip = false,
  enableProductStatusText = false,
}: ProductStockProps) {
  const { t } = useTranslations();
  const selectedVariant = useVariantsStore(state => state.selectedVariant);
  const product = useVariantsStore(state => state.product);
  const availability = selectedVariant?.availability ?? product.availability;
  const isSellable = isSellableFn(selectedVariant ? selectedVariant : product, 1);
  const isProductEnded = product.status === 'ended';
  const isProductArrival = product.status === 'arrival';

  return selectedVariant || product ? (
    <Link href="/doprava" style={{ display: 'contents' }}>
      {enableProductStatusText && (isProductEnded || isProductArrival) ? (
        <span
          className={cn(
            'text-lg font-bold',
            isProductEnded ? 'text-destructive-foreground' : 'text-info',
            isProductEnded ? 'ea-product-stock__ended-text' : 'ea-product-stock__arrival-text',
            className,
          )}
        >
          {t(isProductEnded ? 'text3789' : 'text3790')}
        </span>
      ) : (
        <AvailabilityLabel
          isAvailable={isSellable}
          customName={availability?.name}
          customColor={availability?.color}
          className={className}
          tooltipText={enableTooltip ? availability?.description : undefined}
        />
      )}
    </Link>
  ) : null;
}
